import gql from 'graphql-tag'

export const CREATE_MESSAGE = gql`
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      id
    }
  }
`

export const UPDATE_MESSAGE = gql`
  mutation UpdateMessage($id: ID!, $input: CreateMessageInput!) {
    updateMessage(id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_MESSAGE = gql`
  mutation DeleteMessage($id: ID!) {
    deleteMessage(id: $id) {
      id
    }
  }
`
export const SCHEDULE_MESSAGE = gql`
  mutation ScheduleMessage($id: ID!, $scheduled: Float) {
    scheduleMessage(id: $id, scheduled: $scheduled) {
      id
    }
  }
`
export const DUPLICATE_MESSAGE = gql`
  mutation DuplicateMessage($id: ID!) {
    duplicateMessage(id: $id) {
      id
    }
  }
`

export const SIGN_IN_MUTATION = gql`
  mutation SigninMutation($email: String!, $password: String!) {
    signin(email: $email, password: $password) {
      state
      accessToken
      ucn
      expirationTime
    }
  }
`

export const CREATE_POLL_MUTATION = gql`
  mutation CreatePoll($input: UpdatePollInput!) {
    createPoll(input: $input) {
      id
    }
  }
`

export const UPDATE_POLL_MUTATION = gql`
  mutation UpdatePoll($id: ID!, $input: UpdatePollInput!) {
    updatePoll(id: $id, input: $input) {
      id
    }
  }
`
